export default __webpack_public_path__ + "static/media/Animals-05.85f1c56a.png";